export default "__VITE_ASSET__Ck1OuQ4y__"